export default "__VITE_ASSET__DEUSwGN7__"